import {RadiusDropdownLayoutProps} from "./props";
import React, {useEffect} from "react";
import chevron_up from "../../../icons/chevron-up2.svg";
import chevron_down from "../../../icons/chevron-down2.svg";
import {definedValue} from "../../../utils/input";

export function RadiusDropdownLayout(props: RadiusDropdownLayoutProps) {
  const {
    options,
    selectedOption,
    selectedIndex,
    label,
    handleOptionSelect,
  } = props;
  const [isOpen, setIsOpen] = React.useState(false);
  const dropdownRef = React.useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!dropdownRef.current) {
        return;
      }
      if (!dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  const onOptionSelect = (index: number) => {
    handleOptionSelect?.(index, options[index]);
    setIsOpen(false);
  }
  const inputValue = definedValue(selectedOption, '');
  return (
    <div className='radius-dropdown' ref={dropdownRef}>
      <label className='radius-dropdown__label' htmlFor='radius'>
        {label}
      </label>
      <div
        className='selected-radius__container'
        onClick={() => setIsOpen(!isOpen)}
        role='button'
        aria-expanded={isOpen}
      >
        <input
          id='radius'
          name='radius'
          className='selected-radius__input'
          value={inputValue}
          readOnly={true}
          aria-label={inputValue}
        />
        <img src={isOpen ? chevron_up : chevron_down} alt='toggle icon'/>
      </div>
      {isOpen && (
        <div className='radius-dropdown__options'>
          {options.map((option, i: number) => (
            <div className={`radius-dropdown__option ${i === selectedIndex ? 'selected' : ''}`}
                 key={option}
                 data-testing={`option-${i}`}
                 onClick={() => onOptionSelect(i)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}